export enum StepName {
    companyInfo = "companyInfo",
    pricingPlan = "pricingPlan",
    payment = "payment"
}